import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={58}
            height={58}
            viewBox="0 0 58 58"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <rect width={58} height={58} rx={29} fill={props.isHover ? theme["#0D968F"] : "#F7FEFD"} />
        <path
            d="M37.828 23.01l-6.55-5.24c-1.28-1.02-3.28-1.03-4.55-.01l-6.55 5.25c-.94.75-1.51 2.25-1.31 3.43l1.26 7.54c.29 1.69 1.86 3.02 3.57 3.02h10.6c1.69 0 3.29-1.36 3.58-3.03l1.26-7.54c.18-1.17-.39-2.67-1.31-3.42zM29.748 33c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-3c0-.41.34-.75.75-.75s.75.34.75.75v3z"
            fill={props.isHover ? '#F7FEFD' : theme["#0D968F"]}
        />
        </svg>
    )
}

export default SvgComponent
